(() => {
  if (window.cozyReviewsLoaded) return;
  window.cozyReviewsLoaded = true;
  const instances = new Map();
  function initialize(root) {
    if (instances.has(root)) return;
    const cards = [...root.querySelectorAll('[data-review-card]')];
    const grid = root.querySelector('[data-review-grid]');
    const pageSize = Number(root.dataset.initialCount) || 6;
    const editor = root.dataset.editor === 'true';
    const ratingSelect = root.querySelector('[data-rating-filter]');
    const sortSelect = root.querySelector('[data-review-sort]');
    const more = root.querySelector('[data-review-more]');
    const dialog = root.querySelector('[data-review-dialog]');
    const abort = new AbortController();
    const on = (node,event,fn) => node.addEventListener(event,fn,{signal:abort.signal});
    let photoFilter = 'all', shown = pageSize;
    let layoutFrame;
    function layoutCards() {
      const visible = cards.filter(card => !card.hidden);
      const gap = window.matchMedia('(max-width:749px)').matches ? 16 : 18;
      const spans = visible.map(card => Math.ceil(card.getBoundingClientRect().height + gap));
      visible.forEach((card,index) => card.style.gridRowEnd = `span ${spans[index]}`);
      grid.classList.add('is-masonry');
    }
    function scheduleLayout() {
      cancelAnimationFrame(layoutFrame);
      layoutFrame = requestAnimationFrame(layoutCards);
    }
    const resize = new ResizeObserver(scheduleLayout);
    cards.forEach(card => resize.observe(card));
    root.classList.add('cozy-reviews--enhanced');
    root.querySelectorAll('[data-review-controls]').forEach(e => e.hidden = false);
    function updateExpand() {
      cards.filter(card => !card.hidden).forEach(card => {
        const body = card.querySelector('.cozy-reviews__body');
        const button = card.querySelector('[data-review-expand]');
        if (body && button) button.hidden = !body.classList.contains('is-expanded') && body.scrollHeight <= body.clientHeight + 1;
      });
      layoutCards();
    }
    function render() {
      const rating = ratingSelect.value;
      const matching = cards.filter(card => (photoFilter !== 'photos' || card.dataset.hasPhoto === 'true') && (rating === 'all' || card.dataset.rating === rating));
      const sort = sortSelect.value;
      const originalIndex = new Map(cards.map((card,index) => [card,index]));
      matching.sort((a,b) => {
        let delta = Number(b.dataset.hasPhoto === 'true') - Number(a.dataset.hasPhoto === 'true');
        if (delta) return delta;
        if (sort === 'highest') delta = Number(b.dataset.rating) - Number(a.dataset.rating);
        else if (sort === 'lowest') delta = Number(a.dataset.rating) - Number(b.dataset.rating);
        if (delta) return delta;
        delta = (b.dataset.date || '').localeCompare(a.dataset.date || '');
        return delta || originalIndex.get(a)-originalIndex.get(b);
      });
      cards.forEach(card => card.hidden = !editor);
      matching.forEach((card,index) => {
        card.style.order = index;
        card.hidden = !editor && index >= shown;
      });
      root.querySelector('[data-review-empty]').hidden = matching.length > 0 || editor;
      more.hidden = shown >= matching.length || editor;
      root.querySelector('[data-review-count]').textContent = `Showing ${editor ? cards.length : Math.min(shown,matching.length)} of ${editor ? cards.length : matching.length} reviews`;
      root.querySelectorAll('[data-photo-filter]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.photoFilter === photoFilter)));
      requestAnimationFrame(updateExpand);
    }
    root.querySelectorAll('[data-photo-filter]').forEach(button => on(button,'click',() => {photoFilter = button.dataset.photoFilter;shown=pageSize;render();}));
    on(ratingSelect,'change',() => {shown=pageSize;render();});
    on(sortSelect,'change',() => {shown=pageSize;render();});
    root.querySelectorAll('[data-star-filter]').forEach(button => on(button,'click',() => {
      ratingSelect.value = button.dataset.starFilter;
      photoFilter='all';shown=pageSize;render();
    }));
    on(more,'click',() => {
      const previous = shown;
      shown += pageSize;render();
      const visible = cards.filter(card => !card.hidden).sort((a,b) => Number(a.style.order)-Number(b.style.order));
      requestAnimationFrame(() => visible[previous]?.scrollIntoView({block:'nearest',behavior:'smooth'}));
    });
    cards.forEach(card => {
      const expand = card.querySelector('[data-review-expand]');
      if (expand) on(expand,'click',() => {
        const body = card.querySelector('.cozy-reviews__body');
        const expanded = body.classList.toggle('is-expanded');
        expand.setAttribute('aria-expanded',String(expanded));
        expand.textContent = expanded ? 'Read less' : 'Read more';
        scheduleLayout();
      });
      const photo = card.querySelector('[data-review-photo]');
      if (photo) on(photo,'click',() => {
        const image = dialog.querySelector('img');
        image.src=photo.dataset.fullPhoto;image.alt=photo.querySelector('img').alt;
        dialog.showModal();
      });
    });
    on(dialog.querySelector('[data-review-close]'),'click',() => dialog.close());
    on(dialog,'click',event => {if(event.target===dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();}});
    on(window,'resize',updateExpand);
    if (document.fonts?.ready) document.fonts.ready.then(updateExpand);
    instances.set(root,{abort,dialog,resize,cancelLayout:() => cancelAnimationFrame(layoutFrame)});
    render();
  }
  const scan = () => document.querySelectorAll('[data-cozy-reviews]').forEach(initialize);
  scan();
  document.addEventListener('shopify:section:load',scan);
  document.addEventListener('shopify:block:select',event => {
    const root = event.target.closest('[data-cozy-reviews]');
    if(root) event.target.scrollIntoView({block:'center',behavior:'smooth'});
  });
  document.addEventListener('shopify:section:unload',event => {
    instances.forEach((instance,root) => {if(event.target.contains(root)) {instance.dialog.close();instance.abort.abort();instance.resize.disconnect();instance.cancelLayout();instances.delete(root);}});
  });
})();
